import { memo } from 'react';
import Link from 'next/link';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 0 auto;
`;

const Anchor = styled.a<{ active: boolean }>`
  display: block;
  font-size: 1.6rem;
  font-weight: ${(props) => (props.active ? '800' : '400')};
  margin-right: 0.5rem;
  padding: 1rem 2rem;

  &:last-child {
    margin-right: 0;
  }
`;

const Pagination = ({ pages, section }) => {
  return (
    <Wrapper>
      {pages.map((page) => {
        const url = page.number === 1 ? `/${section}` : page.path;
        return (
          <Link href={url} key={url} passHref legacyBehavior>
            <Anchor active={page.active}>{page.number}</Anchor>
          </Link>
        );
      })}
    </Wrapper>
  );
};

export default memo(Pagination);
